import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, Typography, Paper} from '@material-ui/core'
import ReactMarkdown from 'react-markdown/with-html'
import {FormElement, SubmitButton} from '../../../components/components'
import TabContainer from '../TabContainer'
import CodeBlock from '../../Details/Codeblock'

const styles = {
    submitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '5em',
        marginBottom: '5em',
        alignSelf: 'center'
    },

    readmeTextStyle: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif']
    }
}


class ReadmeEdit extends Component {
    state = {
        isDisabled: false,
        readmeText: '',
        isProcessing: false
    }

    componentDidMount () {
        const {projectDetails} = this.props
        if (projectDetails && projectDetails.readme) this.formInputFields.readme.setValue(projectDetails.readme)
    }

    formInputFields = {}

    onValidationChangeDetected = () => {
        const isDisabled = !this.formInputFields.readme.state.isValid
        this.setState({isDisabled})
    }

    onReadmeChanged = readmeText => {
        this.setState({readmeText});
    }

    onSubmitUpdate = () => {
        let formData = new FormData()
        formData.append('readme', this.state.readmeText)
        this.setState({isProcessing: true})
        this.props.editProjectDetails(this.props.projectDetails.id, formData, () => {
            this.setState({isProcessing: false})
        })
    }

    readmeField = {
        label: 'Content',
        name: 'readme',
        minLength: 5,
        maxLength: 5000,
        type: 'text',
        required: false,
        multiline: true,
        rows: 10,
        rowsMax: 10,
        onChange: this.onReadmeChanged
    }

    render () {
        const {classes: styles, active} = this.props
        const {readmeText, isDisabled, isProcessing} = this.state
        return (
            <TabContainer active={active} className={styles.tabContainer} title={'Update Help/Guide'}>
                <FormElement
                    {...this.readmeField}
                    innerRef={ref => (this.formInputFields[this.readmeField.name] = ref || this.formInputFields[this.readmeField.name])}
                    onValidationChangeDetected={this.onValidationChangeDetected}
                />
                <SubmitButton className={styles.submitButton} isDisabled={isDisabled} isProcessing={isProcessing} loadingText={'Updating'} onClick={this.onSubmitUpdate}>Submit</SubmitButton>
                <Typography variant="h5" color="inherit" className={styles.livePreviewTitle}>
                    Live Preview
                </Typography>
                <Paper className={styles.livePreviewContent} elevation={0}>
                    <ReactMarkdown skipHtml={false} escapeHtml={false} renderers={{code: CodeBlock}} source={readmeText === '' ? 'See few examples [here](https://rexxars.github.io/react-markdown/), for more details check out [GitHub Flavored Markdown](https://github.github.com/gfm/).' : readmeText} className={styles.readmeTextStyle} />
                </Paper>
            </TabContainer>
        )
    }
}

ReadmeEdit.propTypes = {
    classes: PropTypes.object,
    active: PropTypes.bool,
    metas: PropTypes.array,
    isUpdatingProject: PropTypes.bool,
    projectDetails: PropTypes.object,
    editProjectDetails: PropTypes.func
}

export default withStyles(styles)(ReadmeEdit);
